theme_custom.collectionPage = function(){
  var customSortByCreated  = setInterval(function(){ 
    if($(".boost-pfs-filter-top-sorting").length > 0){
      var customSortByCreatedBlock = '';
      customSortByCreatedBlock = `<div class="mobile-sort-header"><span class="sort-title-wrap">Sort <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 14.1 18.9" style="enable-background:new 0 0 14.1 18.9;" xml:space="preserve" width="20px" height="20px"><style type="text/css">.st0{fill:#F1F2F2;stroke:#000000;stroke-miterlimit:10;}</style><image style="display:none;overflow:visible;enable-background:new    ;" width="812" height="454" xlink:href="F7AF1285.jpg" transform="matrix(0.9985 0 0 0.9985 -369.4706 -93.8776)"></image><g><rect x="-460.3" y="-32.1" width="1" height="17"></rect><circle class="st0" cx="-459.7" cy="-21.4" r="2.3"></circle></g><g><rect x="-453.1" y="-32.1" width="1" height="17"></rect><circle class="st0" cx="-452.7" cy="-25.8" r="2.3"></circle></g><g><rect x="3.2" width="0.9" height="17.9"></rect><rect x="1.6" y="14.3" transform="matrix(0.7071 -0.7071 0.7071 0.7071 -11.2091 6.4382)" width="1.1" height="4.9"></rect><rect x="4.4" y="14.3" transform="matrix(0.7071 0.7071 -0.7071 0.7071 13.2877 1.4198)" width="1.1" height="4.9"></rect></g><g><rect x="10.1" y="1" transform="matrix(-1 -1.224647e-16 1.224647e-16 -1 21.0005 19.871)" width="0.9" height="17.9"></rect><rect x="11.4" y="-0.3" transform="matrix(-0.7071 0.7071 -0.7071 -0.7071 21.8658 -4.8145)" width="1.1" height="4.9"></rect><rect x="8.6" y="-0.3" transform="matrix(-0.7071 -0.7071 0.7071 -0.7071 14.1491 10.1034)" width="1.1" height="4.9"></rect></g></svg></span> <span class="popup-close">&#x2715</span></div>`;
      customSortByCreatedBlock += `<ul class="custom-sort-by-wrapper">`;
      customSortByCreatedBlock += `<li class="mobile-sort-title sort-by-header-val"><span class="selected-val"></span></li>`;
      $('.boost-pfs-filter-top-sorting .form-field-select option').each(function(){
        if($(this).is(':selected')){
          customSortByCreatedBlock += `<li class="custom-sort-option active" data-val="`+$(this).attr('value')+`">`+$(this).text()+`</li>`;
        } else {
          customSortByCreatedBlock += `<li class="custom-sort-option" data-val="`+$(this).attr('value')+`">`+$(this).text()+`</li>`;
        }
      });
      customSortByCreatedBlock += `</ul>`;
      $(".sortby-custom-wrapper").append(customSortByCreatedBlock);
      if($(".template-collection")){
        $(".custom-sort-by-outer-wrapper .sort-by-header-val .selected-val").text($(".boost-pfs-filter-top-sorting .form-field-select option:selected").text()).show();
      } 
      if($(".template-search")) {
        if($(".boost-pfs-filter-top-sorting .form-field-select option").is(':selected')){
          $(".custom-sort-by-outer-wrapper .sort-by-header-val .selected-val").text($(".boost-pfs-filter-top-sorting .form-field-select option:selected").text()).show();
        } else {
          $(".custom-sort-by-outer-wrapper .sort-by-header-val .selected-val").text($(".boost-pfs-filter-top-sorting .form-field-select option:first").text()).show();
          $(".custom-sort-by-wrapper .custom-sort-option:first").addClass("active");
        }
      }
      clearInterval(customSortByCreated);
    }
  },1000);
  if($(window).width() < 1024) {
    $( ".custom-sort-by-outer-wrapper" ).click(function() {
      $(".sortby-custom-wrapper").addClass("active");
      $(".site-header-nav--open").css("z-index","1")
      $("body").css("overflow","hidden");
    });
    $(document).on("click",".sortby-custom-wrapper .popup-close", function(){
      $(".sortby-custom-wrapper").removeClass("active");
      $(".site-header-nav--open").css("z-index","700")
      $("body").css("overflow","visible");
    })
  } else {
    $( ".custom-sort-by-outer-wrapper" ).hover(
      function() {
        $(".sortby-custom-wrapper").show();
        $(this).find(".selected-val").addClass("show");
      }, function() {
        $(".sortby-custom-wrapper").hide();
        $(this).find(".selected-val").removeClass("show");
      }
    );
  }
  $(document).on("click", ".custom-sort-by-wrapper .custom-sort-option", function(){
    var targetVal = $(this).attr("data-val");
    $(".custom-sort-by-outer-wrapper .sort-by-header-val .selected-val").text($(this).text());
    $(".custom-sort-by-wrapper .custom-sort-option").removeClass("active");
    $(this).addClass("active");

    var url = window.location.href;
    if(window.location.href.indexOf("sort=") > -1) {
      var otherUrl = url.split('sort=')[0];
      location.replace(otherUrl+'sort='+targetVal);  
    } else {
      if(url.indexOf('?') > -1){
        location.replace(url+'&sort='+targetVal);
      }else{
        location.replace(url+'?sort='+targetVal);
      }
      
    }
  });
  if($(window).width()<860){
    $(document).on("click", ".boost-pfs-filter-close", function(){
      $(".boost-pfs-filter-option-title").removeClass("active");
      $(".boost-pfs-filter-option-content").removeClass("show");
    })
    $(document).on("click", ".boost-pfs-filter-option-title", function(e){
      e.preventDefault();
      // $(".boost-pfs-filter-option").removeClass("active");
      // $(this).closest(".boost-pfs-filter-option").addClass("active");
      
      let $this = $(this);
      if ($this.next().hasClass('show')) {
        $this.next().removeClass('show');
        $this.next().slideUp(350);
        $this.removeClass("active");
      } else {
        $(".boost-pfs-filter-option .boost-pfs-filter-option-title").removeClass("active");
        $this.closest(".boost-pfs-filter-option").find('.boost-pfs-filter-option-title').addClass("active");
        $this.parent().parent().find('.boost-pfs-filter-option .boost-pfs-filter-option-content').removeClass('show');
        // $this.parent().parent().find('.boost-pfs-filter-option .boost-pfs-filter-option-content').slideUp();
        $this.next().toggleClass('show');
        $this.next().slideToggle(350);
      }
    })
  }

  if($(window).width()<860){
    $(document).on("click",".mobile-filter-button", function(){
      if($(window).width() < 767){
        $(".boost-pfs-filter-tree-mobile-button button").click();
      }else {
        $(".productgrid--sidebar, body").addClass("active");
      }
    });
    $(document).on("click",".close-filter-icon", function(){
      $(".productgrid--sidebar, body").removeClass("active");
    })
  }
}

if(window.jQuery)
{
    $(document).ready(function(){
      $(".edit_address .form-field-checkbox").removeClass("default-address");
      $(document).on('click','.add_new_address',function(){
        $('[data-address-id]').removeClass('visible');
        $('[data-address-id="new"]').addClass('visible');
        $('.account-page--column-half .account_menu_list').hide();
      });
      $(document).on('click','.add_new_address_cancel_btn',function(){
        $('[data-address-id="new"]').removeClass('visible');
        $('.account-page--column-half .account_menu_list').show();
      });
      $(document).on("click", ".edit_address .form-field-checkbox", function(){
        if($(this).find('input[type="checkbox"]').is(':checked')){
          $(this).find(".checkmark, .checkmark__check").attr("data-animation-state","checked");
        } else {
          $(this).find(".checkmark, .checkmark__check").attr("data-animation-state","unchecked");
        }
      })
      
    // theme_custom.formValidation
        theme_custom.formValidation = function () {
          $(".form_email").bind("keypress keyup keydown", function (e) {
            if (e.which == 32) {
              return false;
            }
            if ($(this).closest(".form-wrap").find(".form-error.active").length > 0) {
              $(this).closest(".form-wrap").find(".form-error.active").removeClass("active");
            }
            // theme_custom.emailValidation($(this));
          });
          $(".form_field").bind("keypress keyup keydown", function (e) {
            if (e.which == 32) {
              return false;
            }
            theme_custom.fieldValidation($(this));
          });
          $('.form_name').bind("keyup", function (e) {
            theme_custom.nameValidation($(this));
          });

          $(".form_phone").bind("keypress keyup keydown", function(e) {
            theme_custom.phoneValidation($(this));
          });

        };
        //theme_custom.emailValidation
        theme_custom.emailValidation = function ($this) {
          var count = 0;
          var parent = $this.closest(".form-wrap");
          if ($this.val() == "" || $.trim($this.val()) == '') {
            parent.find('.form-error').text('This field is required').addClass("active");
            var count = 1;
          } else {
            function ValidateEmail(email) {
              var expr = /^([\w-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/;
              return expr.test(email);
            };
            if (!ValidateEmail($this.val())) {
              parent.find('.form-error').text('Please enter valid email').addClass("active");
              var count = 1;
            } else {
              parent.find('.form-error').removeClass("active");
            }
          }
          return count;
        }
        // theme_custom.fieldValidation
        theme_custom.fieldValidation = function ($this) {
          var count = 0;
          var parent = $this.closest(".form-wrap");
          var passwordMinlength = parseInt($this.attr("minlength"));
          var passwordMaxlength = parseInt($this.attr("maxlength"));
          
          if ($this.val() == "" || $.trim($this.val()) == '') {
            parent.find('.form-error').text('This field is required').addClass("active");
            count = 1;
          } else {
            if ($this.val().length > passwordMaxlength || $this.val().length < passwordMinlength) {
              parent.find('.form-error').text('Please enter minimum ' + passwordMinlength + ' & maximum length ' + passwordMaxlength + ' ! ').addClass("active");
              count = 1;
            } else {
              parent.find('.form-error').removeClass("active");
            }
          }
          return count;
        }
        // theme_custom.nameValidation
            theme_custom.nameValidation = function ($this) {
              var count = 0;
              var parent = $this.closest(".form-wrap");
              var regex = new RegExp("^[a-zA-Z ]+$");
              var str = $this.val();
              if ($this.val() == "" || $.trim($this.val()) == '') {
                parent.find('.form-error').text('This field is required').addClass("active");
                count = 1;
              } else if ($this.length > 0) {
                if ($this.val().length > 49) {
                  if ($this.val().length > 49) {
                    parent.find(".form-error").text('First name is too long (maximum is 50 characters)').addClass("active");
                  } else {
                    parent.find(".form-error").text('First name is too long (maximum is 50 characters)').removeClass("active");
                  }
                } else {
                  parent.find(".form-error").text('First name is too long (maximum is 50 characters)').removeClass("active");
                  if (regex.test(str)) {
                    parent.find(".form-error").text('Please enter Alphabets').removeClass("active");
                  } else {
                    parent.find(".form-error").text('Please enter Alphabets').addClass("active");
                    count = 1;
                  }
                }
              } else {
                parent.find(".form-error").removeClass("active");
              }
              return count;
            }
        // theme_custom.zipValidation
            theme_custom.zipValidation = function($this) {
              var count = 0;
              var parent = $this.closest(".form-wrap");
              var numbers = /^[A-Za-z0-9_]+$/;
              let targetEl = $this.val().length;
              if (!$this.val().match(numbers)) {
                parent.find('.form-error').text('Please enter valid Zipcode').addClass("active");
                count = 1;
              } else {
                if (targetEl < 3) {
                  parent.find(".form-error").text('Please enter minimum 3 characters').addClass("active");
                  count = 1;
                } else if (targetEl > 8) {
                  parent.find(".form-error").text('Please enter maximum 8 characters').addClass("active");
                  count = 1;
                } else {
                  parent.find(".form-error").removeClass("active");
                }
              }
              return count;
            }
            // theme_custom.phoneValidation
            theme_custom.phoneValidation = function($this) {
              var count = 0;
              var parent = $this.closest(".form-wrap");
              let targetEl = $this.val().length;
              var numbers = /^[0-9]+$/;
              if (!$this.val().match(numbers)) {
                parent.find(".form-error").text('Please enter only number').addClass("active");
                return false;
                count = 1;
              } else {
                if (targetEl < 9) {
                  parent.find(".form-error").text('Please enter minimum 9 characters').addClass("active");
                  count = 1;
                } else if (targetEl > 14) {
                  parent.find(".form-error").text('Please enter maximum 14 characters').addClass("active");
                  count = 1;
                } else {
                  parent.find(".form-error").removeClass("active");
                }
              }
              return count;
            }
        // theme_custom.countryValidation
          theme_custom.countryValidation = function($this){
            var count = 0;
            var parent = $this.closest(".form-wrap");
            if ($this.val() == '---') {
              parent.find(".form-error").text('Please select country').addClass("active");
              count = 1;
            }else{
              parent.find(".form-error").text('Please select country').removeClass("active");
            }
            return count;
          }
        // theme_custom.submitEvent
          theme_custom.submitEvent = function () {
            $('#customer_login').submit(function (e) {
              var error_count = 0;
              error_count = error_count + theme_custom.emailValidation($(this).find('[name="customer[email]"]'));
              error_count = error_count + theme_custom.fieldValidation($(this).find('[name="customer[password]"]'));
              if (error_count > 0) {
                e.preventDefault();
                return false;
              }
            });
            $('#create_customer').submit(function (e) {
              var error_count = 0;
              error_count = error_count + theme_custom.emailValidation($(this).find('[name="customer[email]"]'));
              error_count = error_count + theme_custom.fieldValidation($(this).find('[name="customer[password]"]'));
              error_count = error_count + theme_custom.nameValidation($(this).find('[name="customer[first_name]"]'));
              error_count = error_count + theme_custom.nameValidation($(this).find('[name="customer[last_name]"]'));
             
              if (error_count > 0) {
                return false;
              }
            });
            $('#recovery-form-login').submit(function (e) {
              var error_count = 0;
              error_count = error_count + theme_custom.emailValidation($(this).find('#customer_recovery_email'));
              if (error_count > 0) {
                e.preventDefault();
                return false;
              }
            });
            $('.address_form_edit, #address_form_new').submit(function(e) {
              var error_count = 0;
              error_count = error_count + theme_custom.nameValidation($(this).find('[name="address[first_name]"]'));
              error_count = error_count + theme_custom.nameValidation($(this).find('[name="address[last_name]"]'));
              error_count = error_count + theme_custom.fieldValidation($(this).find('[name="address[address1]"]'));
              error_count = error_count + theme_custom.fieldValidation($(this).find('[name="address[address2]"]'));
              error_count = error_count + theme_custom.nameValidation($(this).find('[name="address[city]"]'));
              error_count = error_count + theme_custom.countryValidation($(this).find('[name="address[country]"]'));
              error_count = error_count + theme_custom.zipValidation($(this).find('[name="address[zip]"]'));
              error_count = error_count + theme_custom.phoneValidation($(this).find('[name="address[phone]"]'));
              if (error_count > 0) {
                return false;
              }
            });
            $("#footer_newsletter_static-footer-1").submit(function(e) {
              var error_count = 0;
              error_count = error_count + theme_custom.emailValidation($(this).find('[name="contact[email]"]'));
              var $this = $(this);
              if (error_count > 0) {
                e.preventDefault();
                // $this.find('[name="contact[email]"]').closest('.form-wrap').find('.form-error').text('Please enter email').addClass("active");
                return false;
              }
            });
            $('.contact-form').submit(function (e) {
              var error_count = 0;
              error_count = error_count + theme_custom.nameValidation($(this).find('[name="contact[name]"]'));
              error_count = error_count + theme_custom.emailValidation($(this).find('[name="contact[email]"]'));
              error_count = error_count + theme_custom.phoneValidation($(this).find('[name="contact[phone]"]'));
              error_count = error_count + theme_custom.fieldValidation($(this).find('[name="contact[message]"]'));
             
              if (error_count > 0) {
                return false;
              }
            });
          }
          setTimeout(function(){
            $(window).resize();
          },8000);
          theme_custom.init();
        });
        theme_custom.init = function () {
          theme_custom.formValidation();
          theme_custom.submitEvent();
          if($(".template-collection, .template-search").length > 0) {
            theme_custom.collectionPage();
          }
        }
        document.addEventListener('readystatechange', event => {
        if (event.target.readyState === "complete") {
          if ($(".template-login").length > 0) {
            var loginPageFormSubmit = setInterval(function() {
              if ($("#customer_login[onsubmit]").length > 0) {
                $("#customer_login").removeAttr("onsubmit");
                $(".btn").removeClass("disable");
                clearInterval(loginPageFormSubmit);
              }
            }, 100);
            var loginPageFormSubmitRecover = setInterval(function() {
              if ($("[action='/account/recover'][onsubmit]").length > 0) {
                $("[action='/account/recover']").removeAttr("onsubmit");
                $(".btn").removeClass("disable");
                clearInterval(loginPageFormSubmitRecover);
              }
            }, 100);
          }
          if ($(".template-register").length > 0) {
            var loginPageFormSubmit = setInterval(function() {
              if ($("#create_customer[onsubmit]").length > 0) {
                $("#create_customer").removeAttr("onsubmit");
                $(".btn").removeClass("disable");
                clearInterval(loginPageFormSubmit);
              }
            }, 100);
          }
          if ($(".contact-form").length > 0) {
            var loginPageFormSubmit = setInterval(function() {
              if ($(".contact-form[onsubmit]").length > 0) {
                $(".contact-form").removeAttr("onsubmit");
                $(".btn").removeClass("disable");
                clearInterval(loginPageFormSubmit);
              }
            }, 100);
          }
        }
    });
    
}

